import { HotelInfoModel } from '@/__generated';
import { useCurrencyFormat } from '@/hooks/useCurrencyFormat';
import React from 'react';

type Props = {
  hotelInfo: HotelInfoModel;
};

export default function SwimmingPool({ hotelInfo }: Props) {
  const { formatCurrency } = useCurrencyFormat();
  if (!hotelInfo.hotelPools?.length) {
    return null;
  }
  return (
    <div id="swimming-pool" className="row y-gap-40 pt-20 pb-20">
      <div className="col-12">
        <h3 className="text-22 fw-500 pt-30 border-top-light">Swimming Pool</h3>
        <div className="row x-gap-10 y-gap-10 mt-20">
          {hotelInfo.hotelPools?.map((pool, index) => {
            return (
              <div className="col-6" key={index}>
                <div className="p-4 rounded text-15 h-100" style={{ backgroundColor: '#f0f8ff' }}>
                  <div className="d-flex ">
                    <div>
                      <i className="ficon ficon-pool mr-5" />
                      Name
                    </div>
                    <div className="fw-500 flex-grow-1 text-end"> {pool.name}</div>
                  </div>
                  <div className="d-flex ">
                    <div>
                      <i className="ficon ficon-currency-exchange mr-5" />
                      Fee (For hotel guest)
                    </div>
                    {pool.fee ? <div className="fw-500 flex-grow-1 text-end text-danger">{formatCurrency(pool.fee)}</div> : null}
                    {pool.fee === 0 ? <div className="fw-500 flex-grow-1 text-end text-success">FREE</div> : null}
                  </div>
                  <div className="d-flex ">
                    <div>
                      <i className="ficon ficon-after-hours mr-5" />
                      Opening hours:
                    </div>
                    <div className="fw-500 flex-grow-1 text-end"> {[pool.openingTime, pool.closingTime].filter(x => x).join(' ~ ')}</div>
                  </div>
                  {pool.width && pool.length && pool.depth ? (
                    <div className="d-flex ">
                      <div>
                        <i className="ficon ficon-regular-pool-seasonal-opening mr-5" />
                        Length with breadth and depth:
                      </div>
                      <div className="fw-500 flex-grow-1 text-end"> {`${pool.width}m - ${pool.length}m - ${pool.depth}cm`}</div>
                    </div>
                  ) : null}

                  <div className="row x-gap-10">
                    {pool.heatedWater ? (
                      <div className="col-4">
                        <i className="pr-5 ficon ficon-hot-tub" />
                        Heated water
                      </div>
                    ) : null}

                    {pool.coldWater ? (
                      <div className="col-4">
                        <i className="pr-5 ficon ficon-air-conditioning" />
                        Cold water
                      </div>
                    ) : null}
                    {pool.isIndoor ? (
                      <div className="col-4">
                        <i className="pr-5 ficon ficon-indoor-poor" />
                        Swimming pool [in door]
                      </div>
                    ) : null}
                    {pool.isOutdoor ? (
                      <div className="col-4">
                        <i className="pr-5 ficon ficon-outdoor-pool" />
                        Swimming pool [out door]
                      </div>
                    ) : null}
                    {pool.hasChildPool ? (
                      <div className="col-4">
                        <i className="pr-5 ficon ficon-pool-kids" />
                        Swimming pool [kids]
                      </div>
                    ) : null}
                    {pool.towelLending ? (
                      <div className="col-4">
                        <i className="pr-5 ficon ficon-towels" />
                        Towel lending
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
